import { Record } from 'immutable';

import { convertActionToPreviousStructure } from 'app/api';
import { ContextNamespace } from 'app/constants/Context';
import { NOTIFY_ABOUT_CHANGED_LANG } from 'app/lang';
import { fetchLiveMainLine } from 'app/modules/Live/actions';
import { APPLY_STATE, SUBSCRIBE, UNSUBSCRIBE } from 'app/modules/Live/actions/liveHub';
import { INIT_ACTION } from 'app/redux/actions/init';
import { SET_LIVE_GRID_ORDER_KEY, SET_LIVE_GRID_STAKE_TYPES } from 'app/redux/betting-presentation/grid/actions';
import { TRANSFORM_SSR_STATE } from 'app/redux/ssrState';

import { reduceGrid } from './entities';
import { reduceGridPresentation } from './presentation';

// ---

const initialState = Record({
  entities: reduceGrid(undefined, INIT_ACTION),
  grid: reduceGridPresentation(undefined, ContextNamespace.LIVE, INIT_ACTION, undefined),
});

const convertibleActions = new Set([
  fetchLiveMainLine.pending.toString(),
  fetchLiveMainLine.fulfilled.toString(),
  fetchLiveMainLine.rejected.toString(),
]);

export default function (state = initialState(), action) {
  switch (action.type) {
    case SUBSCRIBE:
    case UNSUBSCRIBE:
    case APPLY_STATE:
    case NOTIFY_ABOUT_CHANGED_LANG:
    case fetchLiveMainLine.pending.toString():
    case fetchLiveMainLine.fulfilled.toString():
    case fetchLiveMainLine.rejected.toString(): {
      const convertedAction = convertibleActions.has(action.type)
        ? convertActionToPreviousStructure(action)
        : action;

      state = state.update('entities', (state) => reduceGrid(state, convertedAction));

      state = state.update('grid', (currentPresentation) => (
        reduceGridPresentation(currentPresentation, 'live', convertedAction, state.get('entities'))
      ));

      return state;
    }

    case SET_LIVE_GRID_ORDER_KEY:
    case SET_LIVE_GRID_STAKE_TYPES: {
      state = state.update('grid', (currentPresentation) => (
        reduceGridPresentation(currentPresentation, 'live', action, state.get('entities'))
      ));

      return state;
    }

    case TRANSFORM_SSR_STATE: {
      if (Record.isRecord(state)) {
        return state; // already transformed (initial state case)
      }

      const gridEntities = reduceGrid(state.entities, action);

      return initialState({
        entities: gridEntities,
        grid: reduceGridPresentation(state.grid, 'live', action, gridEntities),
      });
    }

    default:
      return state;
  }
}
